/**
 * External dependencies.
 */
import classnames from "classnames";

/**
 * WordPress dependencies.
 */
import { __, sprintf } from "@wordpress/i18n";

const NAVIGATION_ITEMS = [
  {
    slug: "welcome",
    label: __("Welcome", "slideverse"),
    visibility: false,
  },
  {
    slug: "blocks",
    label: __("Blocks", "slideverse"),
    visibility: true,
  },
  {
    slug: "integrations",
    label: __("Integrations", "slideverse"),
    visibility: true,
  },
  {
    slug: "upsell",
    label: __("Free vs PRO", "slideverse"),
    visibility: false,
    // visibility: !Boolean(window.slideverseObj.hasPro),
  },
  {
    slug: "feedback",
    label: __("Feedback", "slideverse"),
    visibility: false,
  },
];

const {slideverseAdminObj} = window;

const Headers = ({ isActive, setActive }) => {
  return (
    <div className="slideverse-navigation">
      <div className="slideverse-navigation-left">
        <img
          src={window.slideverseAdminObj.assetsUrl + "images/admin-logo.png"}
          title={__(
            "SlideVerse – Page Builder Blocks & Extensions for Gutenberg",
            "slideverse"
          )}
        />
      </div>
      <nav className="slideverse-navigation-center">
        {NAVIGATION_ITEMS.map(
          (item) =>
            item.visibility && (
              <a
                className={classnames({
                  "is-active": item.slug === (isActive || "blocks"),
                })}
                onClick={() => setActive(item.slug)}
                key={item.slug}
              >
                <span>{item.label}</span>
              </a>
            )
        )}
      </nav>
      <div className="slideverse-navigation-right">
        <abbr
          title={sprintf(
            __("Version: %s", "slideverse"),
            slideverseAdminObj.version
          )}
          className="version"
        >
          {__("Version", "slideverse")}: {slideverseAdminObj.version}
        </abbr>
      </div>
    </div>
  );
};

export default Headers;
